/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ex_NoteInputs */

const en_to_xml_ex_note = /** @type {(inputs: To_Xml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The apostrophe in a value would be left as is, which is valid in element text content. Only ampersand and less than strictly require escaping there, and this converter also escapes greater than and double quote for safety.`)
};

const ko_to_xml_ex_note = /** @type {(inputs: To_Xml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값 안의 아포스트로피는 그대로 남으며, 요소 텍스트 내용에서는 유효합니다. 그곳에서 엄격하게 이스케이프가 필요한 것은 앰퍼샌드와 여는 부등호뿐이고, 이 변환기는 안전을 위해 닫는 부등호와 큰따옴표도 이스케이프합니다.`)
};

const ja_to_xml_ex_note = /** @type {(inputs: To_Xml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値の中のアポストロフィはそのまま残り、要素のテキスト内容では妥当です。そこで厳密にエスケープが必要なのはアンパサンドと小なりだけで、この変換器は安全のため大なりと二重引用符もエスケープします。`)
};

/**
* | output |
* | --- |
* | "The apostrophe in a value would be left as is, which is valid in element text content. Only ampersand and less than strictly require escaping there, and this..." |
*
* @param {To_Xml_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ex_note = /** @type {((inputs?: To_Xml_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ex_note(inputs)
	if (locale === "ko") return ko_to_xml_ex_note(inputs)
	return ja_to_xml_ex_note(inputs)
});